/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const GUIDE_SET_IS_CARET_VISIBLE = 'GUIDE_SET_IS_CARET_VISIBLE';
export const GUIDE_SET_IS_SPINNER_ACTIVE = 'GUIDE_SET_IS_SPINNER_ACTIVE';
export const LOAD_GRID_GUIDE_CHANNELS = 'LOAD_GRID_GUIDE_CHANNELS';
export const LOAD_GRID_GUIDE_FUTURE_ROWS = 'LOAD_GRID_GUIDE_FUTURE_ROWS';
export const LOAD_GRID_GUIDE_PAST_ROWS = 'LOAD_GRID_GUIDE_PAST_ROWS';
export const LOAD_GRID_GUIDE_ROWS = 'LOAD_GRID_GUIDE_ROWS';
export const ON_LEFT_SET_PREVIOUS_PAGE = 'ON_LEFT_SET_PREVIOUS_PAGE';
export const ON_RIGHT_SET_NEXT_PAGE = 'ON_RIGHT_SET_NEXT_PAGE';
export const REFRESH_GRID_GUIDE = 'REFERSH_GRID_GUIDE';
export const RESET_GRID_GUIDE_CHANNELS = 'RESET_GRID_GUIDE_CHANNELS';
export const RESET_GRID_GUIDE_ROWS = 'RESET_GRID_GUIDE_ROWS';
export const SET_CHANNELS_COUNT = 'SET_CHANNELS_COUNT';
export const SET_GRID_GUIDE_CACHE = 'SET_GRID_GUIDE_CACHE';
export const SET_GRID_GUIDE_CHANNELS_CACHE = 'SET_GRID_GUIDE_CHANNELS_CACHE';
export const SET_GRID_GUIDE_OFFER_PREVIEW_DATA = 'SET_GRID_GUIDE_OFFER_PREVIEW_DATA';
export const SET_GRID_GUIDE_OFFSET = 'SET_GRID_GUIDE_OFFSET';
export const SET_GRID_GUIDE_ROWS = 'SET_GRID_GUIDE_ROWS';
export const SET_GRID_GUIDE_ROWS_CACHE = 'SET_GRID_GUIDE_ROWS_CACHE';
export const SET_GRID_GUIDE_START_TIME = 'SET_GRID_GUIDE_START_TIME';
export const SET_GRID_GUIDE_STATION_IDS = 'SET_GRID_GUIDE_STATION_IDS';
export const SET_GRID_GUIDE_TIMESTAMP_WINDOW = 'SET_GRID_GUIDE_TIMESTAMP_WINDOW';
export const GUIDE_SET_ERROR = 'GUIDE_SET_ERROR';
export const SET_GUIDE_ROWS_SERVICE_FAIL = 'SET_GUIDE_ROWS_SERVICE_FAIL';
export const SET_IS_CHANNELS_SERVICE_FAIL = 'SET_IS_CHANNELS_SERVICE_FAIL';
export const SET_IS_PAST_GUIDE_MODE = 'SET_IS_PAST_GUIDE_MODE';
